import { createVirtualElementWithHtml } from '../../../../services/dom/createVirtualElementWithHtml';
import { HIGHLIGHT_CONTAINER_CLASS } from '../../constants';

/*
 * this step is required because
 * body html is different then html presented on article page
 * (some elements are decorated with additional attributes)
 * apps/app/src/components/ArticleBodyRenderer/services/parseWithoutNonBreakingSpaces.tsx:23
 *
 */
export const cleanHighlightBlockHtml = (html: string): string => {
  const virtualDiv = createVirtualElementWithHtml(html);

  virtualDiv.querySelectorAll('a').forEach((element) => {
    element.removeAttribute('class');
    element.removeAttribute('target');
    element.removeAttribute('rel');
  });

  virtualDiv.querySelectorAll(`.${HIGHLIGHT_CONTAINER_CLASS}`).forEach((element) => {
    // eslint-disable-next-line no-param-reassign
    element.outerHTML = element.innerHTML;
  });

  return virtualDiv.innerHTML;
};
